module.exports = __webpack_public_path__ + "static/media/thenightly_app_download_image_2.75371e6e.webp";